function formatAmount(val) {
  if (val == null) return '0';
  const n = Number(val);
  if (Math.abs(n) >= 1e8) return (n / 1e8).toFixed(2) + ' 亿';
  if (Math.abs(n) >= 1e4) return (n / 1e4).toFixed(2) + ' 万';
  return n.toLocaleString('zh-CN');
}

export default function KpiCards({ stats }) {
  const cards = [
    { label: '经销商总数', value: stats.total_dealers.toLocaleString() },
    { label: '合作中经销商', value: stats.active_dealers.toLocaleString(), primary: true },
    { label: '年度BP总额', value: formatAmount(stats.bp_total) },
    { label: '月均BP', value: formatAmount(stats.bp_monthly_avg) },
    { label: '产品线', value: stats.product_lines },
    { label: 'BU覆盖', value: stats.bu_count },
  ];

  return (
    <div className="kpi-row">
      {cards.map((c, i) => (
        <div className="kpi-card" key={i}>
          <div className="label">{c.label}</div>
          <div className={`value${c.primary ? ' primary' : ''}`}>{c.value}</div>
        </div>
      ))}
    </div>
  );
}
